import React from "react";
import { ApolloProvider } from "@apollo/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import client from "./Utils/apollo";
import Homepage from "./Pages/Homepage";
import Greetings from "./Sections/Greetings/Greetings";
import Photos from "./Sections/Photos/Photos";

const Shell = ({ children }) => {
  return (
    <ApolloProvider client={client}>
      <>{children}</>
    </ApolloProvider>
  );
};

function App() {
  return (
    <Shell>
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/photos" element={<Photos />} />
          <Route path="/greetings" element={<Greetings />} />
        </Routes>
      </Router>
    </Shell>
  );
}

export default App;
